module.exports = __webpack_public_path__ + "static/media/Logo.3f3d04c6.png";